<div class="card card-custom gutter-b">
    <div class="card-header">
        <div class="card-title">
            <h1 class="card-label">Tickets Charts</h1>
        </div>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-12">
                <div class="d-flex justify-content-between mb-2">
                    <div class="date-range">
                        <!--Date-->
                        <div class="form-group row">
                            <div class="col-12">
                                <div class="input-group">
                                    <input class="form-control form-control-lg form-layout"
                                           placeholder="Select range date"
                                           autocomplete="off"
                                           angular-mydatepicker
                                           (dateChanged)="changeDataRange($event)"
                                           [formControl]="myDateRange"
                                           (click)="dp.toggleCalendar()"
                                           [options]="myOptions"
                                           #dp="angular-mydatepicker"/>

                                    <div class="input-group-append">
                                        <button type="button" class="calendar-btn btn-main"
                                                (click)="dp.toggleCalendar()">
                                            <span class="fa fa-calendar"></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="period-options">
                        <select class="form-control form-control-sm" [formControl]="frequencySelect"
                                (change)="changeDataFrequency()">
                            <option value="daily">Daily</option>
                            <option value="weekly">Weekly</option>
                            <option value="monthly">Monthly</option>
                            <option value="quarterly">Quarterly</option>
                            <option value="annual">Annual</option>
                        </select>
                    </div>
                </div>
                <apx-chart
                        *ngIf="lineChartLoaded"
                        [series]="lineChartOptions.series"
                        [chart]="lineChartOptions.chart"
                        [xaxis]="lineChartOptions.xaxis"
                        [yaxis]="lineChartOptions.yaxis"
                        [title]="lineChartOptions.title"
                        [stroke]="lineChartOptions.stroke"
                        [grid]="lineChartOptions.grid"
                        [tooltip]="lineChartOptions.tooltip"
                ></apx-chart>
            </div>

            <div class="col-12 mt-5">
                <div class="row align-items-center">

                    <div class="col-md-8 order-md-0 col-12 order-1">
                        <div class="row">
                            <div class="col-md-4 col-6">
                                <div class="d-flex flex-column">
                                    <span class="text-dark-75 font-weight-bolder font-size-h3">{{totalNewTickets}}</span>
                                    <span class="text-muted font-weight-bold mt-2">Status New</span>
                                </div>

                                <apx-chart
                                        *ngIf="statusNewLoaded"
                                        [series]="areaChartStatusNew.series"
                                        [chart]="areaChartStatusNew.chart"
                                        [xaxis]="areaChartStatusNew.xaxis"
                                        [stroke]="areaChartStatusNew.stroke"
                                        [dataLabels]="areaChartStatusNew.dataLabels"
                                        [yaxis]="areaChartStatusNew.yaxis"
                                        [labels]="areaChartStatusNew.labels"
                                        [legend]="areaChartStatusNew.legend"
                                        [grid]="areaChartStatusNew.grid"
                                        [tooltip]="areaChartStatusNew.tooltip"
                                ></apx-chart>
                            </div>

                            <div class="col-md-4 col-6">
                                <div class="d-flex flex-column">
                                    <span class="text-dark-75 font-weight-bolder font-size-h3">{{totalInProgressTickets}}</span>
                                    <span class="text-muted font-weight-bold mt-2">Status In Progress</span>
                                </div>

                                <apx-chart
                                        *ngIf="statusInProgressLoaded"
                                        [series]="areaChartStatusInProgress.series"
                                        [chart]="areaChartStatusInProgress.chart"
                                        [xaxis]="areaChartStatusInProgress.xaxis"
                                        [stroke]="areaChartStatusInProgress.stroke"
                                        [dataLabels]="areaChartStatusInProgress.dataLabels"
                                        [yaxis]="areaChartStatusInProgress.yaxis"
                                        [labels]="areaChartStatusInProgress.labels"
                                        [legend]="areaChartStatusInProgress.legend"
                                        [grid]="areaChartStatusInProgress.grid"
                                        [tooltip]="areaChartStatusInProgress.tooltip"

                                ></apx-chart>
                            </div>

                            <div class="col-md-4 col-6">
                                <div class="d-flex flex-column">
                                    <span class="text-dark-75 font-weight-bolder font-size-h3">{{totalDoneTickets}}</span>
                                    <span class="text-muted font-weight-bold mt-2">Status Done</span>
                                </div>

                                <apx-chart
                                        *ngIf="statusDoneLoaded"
                                        [series]="areaChartStatusDone.series"
                                        [chart]="areaChartStatusDone.chart"
                                        [xaxis]="areaChartStatusDone.xaxis"
                                        [stroke]="areaChartStatusDone.stroke"
                                        [dataLabels]="areaChartStatusDone.dataLabels"
                                        [yaxis]="areaChartStatusDone.yaxis"
                                        [labels]="areaChartStatusDone.labels"
                                        [legend]="areaChartStatusDone.legend"
                                        [grid]="areaChartStatusDone.grid"
                                        [tooltip]="areaChartStatusDone.tooltip"
                                ></apx-chart>
                            </div>

                            <div class="col-md-4 col-6">
                                <div class="d-flex flex-column">
                                    <span class="text-dark-75 font-weight-bolder font-size-h3">{{totalCancelledTickets}}</span>
                                    <span class="text-muted font-weight-bold mt-2">Status Cancelled</span>
                                </div>

                                <apx-chart
                                        *ngIf="statusCancelledLoaded"
                                        [series]="areaChartStatusCancelled.series"
                                        [chart]="areaChartStatusCancelled.chart"
                                        [xaxis]="areaChartStatusCancelled.xaxis"
                                        [stroke]="areaChartStatusCancelled.stroke"
                                        [dataLabels]="areaChartStatusCancelled.dataLabels"
                                        [yaxis]="areaChartStatusCancelled.yaxis"
                                        [labels]="areaChartStatusCancelled.labels"
                                        [legend]="areaChartStatusCancelled.legend"
                                        [grid]="areaChartStatusCancelled.grid"
                                        [tooltip]="areaChartStatusCancelled.tooltip"
                                ></apx-chart>
                            </div>


                        </div>
                    </div>

                    <div class="col-md-4 order-md-1 col-12 order-0">
                        <apx-chart
                                *ngIf="pieLoaded"
                                [series]="pieChartOptions.series"
                                [chart]="pieChartOptions.chart"
                                [labels]="pieChartOptions.labels"
                                [responsive]="pieChartOptions.responsive"
                        ></apx-chart>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
